import { Observable } from 'rxjs';

import { SeamPattern, SeamRequest } from 'app/model';
import { ModelPrepped } from 'app/type/model-prepped';

import { RestfulApiService } from './restful-api.service';

class SeamPatternService extends RestfulApiService<SeamPattern, SeamRequest> {
    public recomputePatterns(request: SeamRequest): Observable<void> {
        const url = `${this.getUrl(request)}/recompute`;

        return this.http.get(url);
    }
    protected getFormName(): string {
        return 'seam_pattern';
    }

    protected getPath(parent: SeamRequest | undefined): string {
        if (undefined === parent) {
            throw new Error('You must provide parent');
        }

        return `seam-workflows/${parent.id}/patterns`;
    }

    protected prepareSaveData(entity: SeamPattern): ModelPrepped<SeamPattern> {
        return {
            ...entity,
            position: undefined,
            outputId: undefined,
            cobrander: undefined,
            viewOnly: undefined,
            opposingId: undefined,
        };
    }
}

export const seamPatternService = new SeamPatternService();
